import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import classes from './style.module.scss';

const Banner = ({ title, text, children }) => (
    <section className={classNames('flex bg-co-white', classes.container)}>
        <i className={classes.icon}/>
        <section className={classNames('flex flex-col flex-justify-center', classes.content)}>
            <h6 className={classNames({ 'm-b-8': text })}>
                {title}
            </h6>
            {text && <p>
                {text}
            </p>}
            {children}
        </section>
    </section>
);

Banner.propTypes = {
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    text: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ])
};

export default Banner;
